exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-subheader {\n  padding-left: 0px;\n  padding-right: 10px;\n}\n.page-subheader .items-per-page {\n  display: inline-block;\n  vertical-align: top;\n  text-align: right;\n  float: right;\n}\n.page-subheader .items-per-page label {\n  display: inline-block;\n  margin-right: 10px;\n  font-weight: 400;\n}\n.page-subheader .items-per-page .sel {\n  display: inline-block;\n  position: relative;\n}\n.page-subheader .items-per-page .sel select {\n  border-radius: 5px;\n  padding: 2px;\n}\n", ""]);

// exports
